import {
  Card,
  CardContent,
  CardHeader,
  Grid
} from "@dealer-center/core-components";
import styled from "styled-components";
import type {
  AccountEntity,
  Department
} from "@dealer-center/ddc-api-account-interface";
import { useOutletContext } from "react-router-dom";
import {
  PagesLandingPageListItem,
  StyledUnorderedList,
  StyledUnorderedListHeader
} from "@dealer-center/ddc-core-custom-components";

const StyledCard = styled(Card)`
  .panel-title {
    width: 100%;
  }
`;
const hasAddress = (department: Department) => {
  return (
    department.address.address1 ||
    department.address.address2 ||
    department.address.address3 ||
    department.address.city ||
    department.address.state ||
    department.address.postalCode ||
    department.address.country
  );
};
const hasHours = (department: Department) => {
  return (
    department.hours.monday ||
    department.hours.tuesday ||
    department.hours.wednesday ||
    department.hours.thursday ||
    department.hours.friday ||
    department.hours.saturday ||
    department.hours.sunday
  );
};
export function DashboardDepartmentsOld() {
  const { accountEntity } = useOutletContext<{
    accountEntity: AccountEntity;
  }>();
  return (
    <Grid
      container
      data-testid={"basic-grid-container-id"}
      id={"basic-container-grid"}
      marginBlockEnd={2}
      spacing={2}
    >
      {accountEntity.departments.map(department => (
        <Grid key={department.label} size={{ lg: 3, sm: 6, xs: 12 }}>
          <StyledCard
            content={
              <CardContent>
                <StyledUnorderedList>
                  {hasAddress(department) && (
                    <>
                      <StyledUnorderedListHeader>
                        Address
                      </StyledUnorderedListHeader>
                      <StyledUnorderedList>
                        {department.address.address1 && (
                          <PagesLandingPageListItem
                            label="Address"
                            value={department.address.address1}
                          />
                        )}
                        {department.address.address2 && (
                          <PagesLandingPageListItem
                            label="Address 2"
                            value={department.address.address2}
                          />
                        )}
                        {department.address.address3 && (
                          <PagesLandingPageListItem
                            label="Address 3"
                            value={department.address.address3}
                          />
                        )}
                        {department.address.city && (
                          <PagesLandingPageListItem
                            label="City"
                            value={department.address.city}
                          />
                        )}
                        {department.address.state && (
                          <PagesLandingPageListItem
                            label="State"
                            value={department.address.state}
                          />
                        )}
                        {department.address.postalCode && (
                          <PagesLandingPageListItem
                            label="Postal Code"
                            value={department.address.postalCode}
                          />
                        )}
                        {department.address.country && (
                          <PagesLandingPageListItem
                            label="Country"
                            value={department.address.country}
                          />
                        )}
                      </StyledUnorderedList>
                    </>
                  )}
                  {hasHours(department) && (
                    <>
                      <StyledUnorderedListHeader>
                        Hours
                      </StyledUnorderedListHeader>
                      <StyledUnorderedList>
                        <PagesLandingPageListItem
                          label="Mo"
                          value={department.hours.monday}
                        />
                        <PagesLandingPageListItem
                          label="Tu"
                          value={department.hours.tuesday}
                        />
                        <PagesLandingPageListItem
                          label="We"
                          value={department.hours.wednesday}
                        />
                        <PagesLandingPageListItem
                          label="Th"
                          value={department.hours.thursday}
                        />
                        <PagesLandingPageListItem
                          label="Fr"
                          value={department.hours.friday}
                        />
                        <PagesLandingPageListItem
                          label="Sa"
                          value={department.hours.saturday}
                        />
                        <PagesLandingPageListItem
                          label="Su"
                          value={department.hours.sunday}
                        />
                      </StyledUnorderedList>
                    </>
                  )}
                  {department.contactInformation.phoneNumbers.map(
                    phoneNumber => (
                      <PagesLandingPageListItem
                        key={phoneNumber.type}
                        label={phoneNumber.type}
                        value={phoneNumber.number}
                      />
                    )
                  )}
                  {department.contactInformation.email && (
                    <PagesLandingPageListItem
                      label="Email"
                      value={department.contactInformation.email}
                    />
                  )}
                  {department.type && (
                    <PagesLandingPageListItem
                      label="Type"
                      value={department.type}
                    />
                  )}
                </StyledUnorderedList>
              </CardContent>
            }
            header={<CardHeader title={department.label} />}
          />
        </Grid>
      ))}
    </Grid>
  );
}
